import { render, staticRenderFns } from "./BroadCasterProductListLive.vue?vue&type=template&id=ab4b3982&"
import script from "./BroadCasterProductListLive.vue?vue&type=script&lang=js&"
export * from "./BroadCasterProductListLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports